import {HttpRequest} from '../../util/http';

export const getUsername = (email) => {
  const method = 'POST'
  const data = { email }

  return HttpRequest.fetch('/scripts/auth/retrieve_username', { method, data })
}
